import React from 'react';
import {EditorEvent} from '../events';
import {
    ConfigCallbackProps,
    configCallbackPropTypes,
    ConfigProps,
    configPropTypes,
    editorDefaultProps,
    EditorProps,
    editorPropTypes,
    mapDefaultProps,
    MapProps,
    mapPropTypes,
} from './props';
import UnconnectedMapEditor from './UnconnectedMapEditor';
import connectBase from './connectBase';

/**
 * Mapový editor (varianta s konfigurací mapy na vstupu).
 * Interní skrytá implementace.
 *
 * @ignore
 */
const ConnectedBaseMapEditor = connectBase<EditorProps, EditorEvent>(UnconnectedMapEditor);

/**
 * Properties mapového editoru (varianta s konfigurací mapy na vstupu).
 */
export type BaseMapEditorProps = MapProps<EditorEvent> & EditorProps & ConfigProps & ConfigCallbackProps;

/**
 * Mapový editor (varianta s konfigurací mapy na vstupu).
 *
 * @param props - Properties komponenty.
 * @returns Element.
 */
export default function BaseMapEditor(props: BaseMapEditorProps): JSX.Element {
    return <ConnectedBaseMapEditor debugName="BaseMapEditor" {...props} />;
}

/**
 * Typy properties.
 */
BaseMapEditor.propTypes = {
    ...mapPropTypes,
    ...editorPropTypes,
    ...configPropTypes,
    ...configCallbackPropTypes,
};

/**
 * Výchozí hodnoty properties.
 */
BaseMapEditor.defaultProps = {
    ...mapDefaultProps,
    ...editorDefaultProps,
};
